var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert"},[_c('v-alert',{attrs:{"elevation":"9","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }